import * as React from 'react';

interface containerProps {
  onChange: (newValue: boolean) => void
  isEnabled: boolean
  isChecked: boolean
  label: string
}

interface containerState {
  isEnabled: boolean
  isChecked: boolean
  label: string
}

export class CheckBox extends React.Component<containerProps, containerState> {
  state: containerState = {
    isEnabled: false,
    isChecked: false,
    label: ''
  }
  constructor(props) {
    super(props);
    this.state.isEnabled = this.props.isEnabled;
    this.state.isChecked = this.props.isChecked;
    this.state.label = this.props.label;
  }

  componentDidUpdate(prevProps: Readonly<containerProps>, prevState: Readonly<containerState>, snapshot?: any) {
    if (this.props.isChecked != prevProps.isChecked)
      this.setState({isChecked: this.props.isChecked});
  }

  updateStatus() {
    const { isChecked } = this.state;
    const { onChange } = this.props;
    this.setState({ isChecked: !isChecked }, () => onChange(!isChecked));
  }

  render() {
    const { isChecked, isEnabled, label } = this.state;
    return (
      <div>
        <i className={(isChecked ? "fas fa-check-square" : "far fa-square")} onClick={() => {
          this.updateStatus();
        }}></i>&nbsp;{label}
      </div>
    );
  }
}